export interface ListProps<TItem> {
  items: TItem[];
  children?: (item: TItem) => React.ReactNode;
  getKey: (item: TItem) => string;
}

export function List<TItem>(props: ListProps<TItem>): React.ReactNode {
  return (
    <ul className="flex w-full flex-col divide-y divide-border-default">
      {props.items.map((item, index) => {
        const content = props.children?.(item);

        if (!content && typeof item === "string") {
          return <li key={`${item}-${index}`}>{item}</li>;
        } else if (!content) {
          return null;
        }

        return (
          <li className="w-full py-space-md" key={props.getKey?.(item)}>
            {content}
          </li>
        );
      })}
    </ul>
  );
}
